import { get, post, put } from '../Services/http'
import { catchError } from './Error.action'
import { show as showNotification } from './Notification.action'
import { gtmEvent } from '../Services/DataLayerAddOrRemoveCart'

export const CART_LOAD = 'CART_LOAD'
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR'
export const CART_RECEIVE = 'CART_RECEIVE'
export const CART_SHOW_INFO = 'CART_SHOW_INFO'
export const CART_HIDE = 'CART_HIDE'
export const ADD_TO_CART_LOADING = 'ADD_TO_CART_LOADING'

export const load = () => (dispatch, getState) => {
    return get('/api/cart')
        .then((response) => response.json())
        .then((cart) => dispatch(receive(cart)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}

export const loadError = (error) => ({
    type: CART_LOAD_ERROR,
    payload: {
        error,
    },
})

export const receive = (cart) => ({
    type: CART_RECEIVE,
    payload: cart,
})

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().cart.showInfo))
}

const show = (visible) => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible,
    },
})

export const add = ({
    articleNumber,
    quantity = 1,
    nodeIdToShowNotification = null,
    notificationMessage = null,
    hash = '',
}) => {
    return (dispatch) => {
        if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
            return
        }

        return post('/api/cart/add', {
            articleNumber,
            quantity: parseInt(quantity),
        })
            .then((response) => response.json())
            .then((cart) => {
                dispatch(receive(cart))
                nodeIdToShowNotification &&
                    dispatch(
                        showNotification(
                            nodeIdToShowNotification,
                            notificationMessage,
                            hash
                        )
                    )
            })
            .catch((ex) => {
                dispatch(catchError(ex, (error) => loadError(error)))
            })
    }
}

export const addCompleteWheels = (products) => {
    return (dispatch) => {
        if(products.some(product => !product.quantity || isNaN(product.quantity) || parseInt(product.quantity) <= 0))
            return

        dispatch({
            type: ADD_TO_CART_LOADING,
            payload: {
                isLoading: true
            }
        })

        return post('/api/cart/addCompleteWheels', {products})
            .then((response) => response.json())
            .then((cart) => {
                dispatch(receive(cart))
                dispatch({
                    type: ADD_TO_CART_LOADING,
                    payload: {
                        isLoading: false
                    }
                })
            })
            .catch((ex) => {
                dispatch(catchError(ex, (error) => loadError(error)))
                dispatch({
                    type: ADD_TO_CART_LOADING,
                    payload: {
                        isLoading: false,
                        error: true
                    }
                })
            })
    }
}

export const reorder = ({
    orderId,
    nodeIdToShowNotification = null,
    notificationMessage = null,
    hash = '',
}) => {
    if (orderId) {
        return (dispatch) => {
            return post('/api/cart/reorder', { orderId })
                .then((response) => response.json())
                .then((cart) => {
                    dispatch(receive(cart))
                    nodeIdToShowNotification &&
                        dispatch(
                            showNotification(
                                nodeIdToShowNotification,
                                notificationMessage,
                                hash
                            )
                        )
                })
                .catch((ex) =>
                    dispatch(catchError(ex, (error) => loadError(error)))
                )
        }
    }
}

export const update = (rowSystemId, quantity) => (dispatch, getState) => {
    if (quantity == 0) {
        gtmEvent('remove', rowSystemId, 0)
    }

    const checkoutState = getState().checkout.payload

    return put(`/api/cart/update`, { rowSystemId, quantity })
        .then((response) => response.json())
        .then((payload) => {
            dispatch({
                type: 'CHECKOUT_SET_DELIVERY',
                payload: {
                    deliveryMethods: payload.deliveryMethods,
                    tpmsProduct: payload.tpmsProduct
                }
            })

            if(payload.deliveryMethods.length == 1 && checkoutState.selectedDeliveryMethod != payload.deliveryMethods[0].id)
                dispatch({
                    type: "CHECKOUT_SET_DELIVERY",
                    payload: {
                        selectedDeliveryMethod: payload.deliveryMethods[0].id,
                    },
                })

            dispatch(receive(payload.cart))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}

export const submitOrderRowComment = (rowSystemId, comment) => (dispatch) => {
    return put(`/api/cart/setOrderRowComment`, { rowSystemId, comment })
        .then((response) => response.json())
        .then((cart) => dispatch(receive(cart)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))))
}
